var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthidAuthenticator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 53.34,
    y1: 125.88,
    x2: 11.46,
    y2: 202.94,
    gradientTransform: "translate(0 -62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9580bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 177.68,
    y1: 180.76,
    x2: 207.83,
    y2: 124.36,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 133.79,
    y1: 121.47,
    x2: 96.93,
    y2: 196.3,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 53.7,
    y1: 125.82,
    x2: 11.82,
    y2: 202.88,
    gradientTransform: "translate(0 -62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9580bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b215b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 178.04,
    y1: 180.7,
    x2: 208.19,
    y2: 124.3,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 134.14,
    y1: 121.41,
    x2: 97.29,
    y2: 196.24,
    xlinkHref: "#l"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "authid-logo-250x250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.22,195.08v-.91c0-6.27-3.11-9.38-9.32-9.38-4.26,0-7.92,1.4-11.09,4.26l-3.11-3.65c3.41-3.53,8.53-5.3,15.35-5.3,1.77,0,3.47.24,5.06.79,1.64.55,3.05,1.28,4.2,2.38,1.22,1.04,2.13,2.38,2.86,4.02.73,1.58,1.1,3.53,1.1,5.73v16.2c0,1.4.06,2.86.18,4.39.12,1.52.24,2.8.43,3.78h-4.93c-.18-.85-.24-1.83-.37-2.86-.06-1.04-.12-2.01-.12-3.05h-.18c-1.52,2.44-3.29,4.2-5.3,5.24-2.07,1.04-4.51,1.58-7.49,1.58-1.58,0-3.17-.24-4.63-.67-1.52-.43-2.8-1.1-4.02-2.01-1.16-.91-2.07-2.01-2.8-3.35-.67-1.34-1.04-2.86-1.04-4.63,0-2.92.79-5.24,2.31-6.94,1.52-1.71,3.41-2.92,5.73-3.78s4.75-1.34,7.37-1.52c2.62-.18,4.99-.3,7.19-.3M27.6,199.28c-1.28,0-2.92.06-4.87.18s-3.78.43-5.6.91c-1.77.49-3.29,1.28-4.57,2.31s-1.89,2.44-1.89,4.26c0,1.22.24,2.19.73,3.05.49.85,1.16,1.52,1.95,2.07.85.55,1.77.91,2.74,1.16,1.04.24,2.01.37,3.05.37,1.89,0,3.47-.3,4.87-.91,1.34-.61,2.5-1.46,3.47-2.5.91-1.04,1.64-2.31,2.07-3.72.43-1.4.67-2.92.67-4.51v-2.62h-2.62v-.06h0Z",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,217.31c-.12-.97-.18-1.95-.18-2.92s-.06-1.95-.06-2.92h-.18c-.55.97-1.28,1.89-2.19,2.74-.85.85-1.89,1.52-2.92,2.13-1.1.61-2.25,1.04-3.47,1.4-1.22.3-2.44.49-3.59.49-4.63,0-8.1-1.22-10.29-3.65s-3.35-5.97-3.35-10.48v-23.03h5.12v20.1c0,2.01.18,3.78.49,5.36.3,1.52.85,2.86,1.58,3.9s1.77,1.89,3.05,2.38c1.28.55,2.86.79,4.75.79.24,0,.97-.12,2.19-.3s2.44-.79,3.78-1.71,2.5-2.31,3.53-4.2c1.04-1.89,1.52-4.45,1.52-7.74v-18.58h5.12v28.32c0,.97.06,2.19.12,3.72.06,1.52.18,2.92.24,4.26",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,185.7h-10.48v21.38c0,1.34.12,2.44.37,3.29.24.85.61,1.52,1.1,1.95.49.49,1.04.79,1.64.97.67.18,1.34.24,2.13.24.85,0,1.77-.12,2.74-.37.91-.24,1.77-.61,2.56-1.04l.24,4.75c-1.89.85-4.2,1.34-6.88,1.34-.97,0-2.01-.12-3.05-.37-1.04-.24-2.01-.73-2.92-1.46-.85-.73-1.58-1.71-2.19-2.92-.55-1.22-.85-2.86-.85-4.87v-22.84h-7.68v-4.63h7.68v-10.23h5.12v10.23h10.48",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.25,
    y: 163.35,
    width: 12.12,
    height: 54.88,
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.29,163.35h18.15c4.39,0,8.59.49,12.55,1.46s7.43,2.56,10.36,4.75c2.92,2.19,5.3,5.06,7.01,8.59,1.71,3.53,2.62,7.8,2.62,12.79,0,4.45-.85,8.35-2.5,11.76-1.71,3.41-3.96,6.21-6.76,8.53-2.86,2.31-6.15,4.02-9.87,5.24-3.72,1.22-7.61,1.77-11.7,1.77h-19.8M200.41,207.08h6.27c2.8,0,5.36-.3,7.8-.85,2.38-.55,4.51-1.52,6.21-2.8,1.77-1.34,3.17-3.05,4.14-5.18,1.04-2.13,1.52-4.75,1.52-7.86,0-2.68-.49-5.06-1.52-7.01-1.04-2.01-2.38-3.65-4.08-4.93s-3.72-2.25-6.03-2.92c-2.31-.67-4.69-.97-7.25-.97h-7.13v32.53h.06Z",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22,195.08v-.91c0-6.27-3.11-9.38-9.32-9.38-4.26,0-7.92,1.4-11.09,4.26l-3.11-3.65c3.41-3.53,8.53-5.3,15.35-5.3,1.77,0,3.47.24,5.06.79,1.64.55,3.05,1.28,4.2,2.38,1.22,1.04,2.13,2.38,2.86,4.02.73,1.58,1.1,3.53,1.1,5.73v16.2c0,1.4.06,2.86.18,4.39.12,1.52.24,2.8.43,3.78h-4.93c-.18-.85-.24-1.83-.37-2.86-.06-1.04-.12-2.01-.12-3.05h-.18c-1.52,2.44-3.29,4.2-5.3,5.24-2.07,1.04-4.51,1.58-7.49,1.58-1.58,0-3.17-.24-4.63-.67-1.52-.43-2.8-1.1-4.02-2.01-1.16-.91-2.07-2.01-2.8-3.35-.67-1.34-1.04-2.86-1.04-4.63,0-2.92.79-5.24,2.31-6.94,1.52-1.71,3.41-2.92,5.73-3.78s4.75-1.34,7.37-1.52c2.62-.18,4.99-.3,7.19-.3h2.62ZM27.6,199.28c-1.28,0-2.92.06-4.87.18s-3.78.43-5.6.91c-1.77.49-3.29,1.28-4.57,2.31s-1.89,2.44-1.89,4.26c0,1.22.24,2.19.73,3.05.49.85,1.16,1.52,1.95,2.07.85.55,1.77.91,2.74,1.16,1.04.24,2.01.37,3.05.37,1.89,0,3.47-.3,4.87-.91,1.34-.61,2.5-1.46,3.47-2.5.91-1.04,1.64-2.31,2.07-3.72.43-1.4.67-2.92.67-4.51v-2.62h-2.62v-.06h0Z",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.71,217.31c-.12-1.34-.18-2.74-.24-4.26-.06-1.52-.12-2.74-.12-3.72v-28.32h-5.12v18.58c0,3.29-.55,5.91-1.52,7.74-1.04,1.89-2.19,3.23-3.53,4.2-1.34.91-2.56,1.52-3.78,1.71s-1.89.3-2.19.3c-1.89,0-3.47-.24-4.75-.79-1.28-.55-2.25-1.34-3.05-2.38-.73-1.04-1.28-2.38-1.58-3.9s-.49-3.35-.49-5.36v-20.1h-5.12v23.03c0,4.57,1.1,8.04,3.35,10.48,2.19,2.44,5.66,3.65,10.29,3.65,1.22,0,2.38-.18,3.59-.49,1.22-.37,2.38-.79,3.47-1.4s2.07-1.28,2.92-2.13c.85-.85,1.58-1.71,2.19-2.74h.18c0,.97,0,1.95.06,2.92,0,.97.06,1.95.18,2.92h5.24v.06h0Z",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,185.7h-10.48v21.38c0,1.34.12,2.44.37,3.29.24.85.61,1.52,1.1,1.95.49.49,1.04.79,1.64.97.67.18,1.34.24,2.13.24.85,0,1.77-.12,2.74-.37.91-.24,1.77-.61,2.56-1.04l.24,4.75c-1.89.85-4.2,1.34-6.88,1.34-.97,0-2.01-.12-3.05-.37-1.04-.24-2.01-.73-2.92-1.46-.85-.73-1.58-1.71-2.19-2.92-.55-1.22-.85-2.86-.85-4.87v-22.84h-7.68v-4.63h7.68v-10.23h5.12v10.23h10.48v4.57h0Z",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.31,218.23h5.12v-18.58c0-3.29.49-5.91,1.52-7.74,1.04-1.89,2.19-3.23,3.53-4.2,1.34-.91,2.56-1.52,3.78-1.71s1.89-.3,2.19-.3c3.78,0,6.34,1.1,7.74,3.23s2.07,5.24,2.07,9.26v20.1h5.12v-23.03c0-4.57-1.1-8.04-3.35-10.48s-5.66-3.65-10.29-3.65c-1.22,0-2.38.18-3.59.49-1.22.37-2.38.79-3.47,1.4s-2.07,1.28-2.92,2.13c-.85.85-1.58,1.71-2.19,2.74h-.18v-24.37h-5.12v54.7h.06Z",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.25,
    y: 163.35,
    width: 12.12,
    height: 54.88,
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.29,163.35h18.15c4.39,0,8.59.49,12.55,1.46s7.43,2.56,10.36,4.75c2.92,2.19,5.3,5.06,7.01,8.59,1.71,3.53,2.62,7.8,2.62,12.79,0,4.45-.85,8.35-2.5,11.76-1.71,3.41-3.96,6.21-6.76,8.53-2.86,2.31-6.15,4.02-9.87,5.24-3.72,1.22-7.61,1.77-11.7,1.77h-19.8v-54.88h-.06ZM200.41,207.08h6.27c2.8,0,5.36-.3,7.8-.85,2.38-.55,4.51-1.52,6.21-2.8,1.77-1.34,3.17-3.05,4.14-5.18,1.04-2.13,1.52-4.75,1.52-7.86,0-2.68-.49-5.06-1.52-7.01-1.04-2.01-2.38-3.65-4.08-4.93s-3.72-2.25-6.03-2.92c-2.31-.67-4.69-.97-7.25-.97h-7.13v32.53h.06Z",
    style: {
      fill: "#2b215b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.04,218.05c-.55,0-1.04-.12-1.52-.3s-.91-.49-1.28-.85-.67-.79-.85-1.28c-.18-.49-.3-.97-.3-1.52s.12-1.04.3-1.52.49-.91.85-1.22.79-.67,1.28-.85c.49-.18.97-.3,1.52-.3s1.04.12,1.52.3.91.49,1.28.85c.37.37.67.79.85,1.22.18.49.3.97.3,1.52s-.12,1.04-.3,1.52-.49.91-.85,1.28c-.37.37-.79.67-1.28.85-.43.24-.97.3-1.52.3ZM241.04,217.13c.55,0,1.04-.12,1.52-.43.43-.24.79-.61,1.1-1.1.24-.43.43-.97.43-1.52s-.12-1.04-.43-1.52c-.24-.43-.61-.79-1.1-1.1-.43-.24-.97-.43-1.52-.43s-1.04.12-1.52.43c-.43.24-.79.61-1.1,1.1-.24.43-.43.97-.43,1.52s.12,1.04.43,1.52c.24.43.61.79,1.1,1.1s.97.43,1.52.43ZM239.76,215.97v-3.78h1.64c.37,0,.67.12.91.37.24.24.37.55.37.85,0,.24-.06.43-.18.61s-.3.37-.55.49l.73,1.46h-.73l-.67-1.34h-.91v1.34h-.61ZM240.37,214.09h1.04c.18,0,.3-.06.43-.18s.18-.24.18-.43-.06-.37-.18-.43c-.12-.12-.24-.18-.43-.18h-1.04v1.22Z",
    style: {
      fill: "#2b215b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    "data-name": "SVGID",
    d: "M12.68,140.99h0c-6.88-3.53-9.56-11.94-6.09-18.76,0,0,24.73-48.37,27.72-54.15,2.92-5.79,7.86-7.8,11.82-7.8h4.75c4.81,2.44,9.99,8.83,9.99,13.89,0,2.13-.49,4.32-1.52,6.34l-27.84,54.4c-3.59,6.88-12,9.62-18.82,6.09",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    "data-name": "SVGID-2",
    d: "M236.97,61.74c-1.71-.85-4.2-1.46-6.7-1.46h-67.49l14.07,27.9h31.07l-17.54,34.05c-3.53,6.88-.79,15.29,6.09,18.76v.12c6.88,3.53,15.29.67,18.76-6.21l27.84-54.34c3.47-6.88.73-15.29-6.09-18.82",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    "data-name": "SVGID-3",
    d: "M92.91,140.99h0c-6.88-3.53-8.95-13.22-5.42-20.1l27.17-53.12c3.53-6.88,7.31-7.68,10.72-7.68l8.04,1.58c6.88,3.53,9.56,11.94,6.09,18.76l-27.84,54.52c-3.53,6.82-11.94,9.56-18.76,6.03",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "j",
    "data-name": "SVGID-4",
    d: "M70.8,115.35c0-6.4-5.18-11.63-11.63-11.63s-11.63,5.18-11.63,11.63,5.18,11.63,11.63,11.63,11.63-5.24,11.63-11.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.07,60.16c0,.06,25.46,0,25.46,0,4.51,0,7.37,1.71,9.81,5.73,2.38,3.96,33.44,64.63,35.39,68.16,1.95,3.53,4.14,7.8,7.61,8.65h-28.93c-5.06,0-7.98-3.78-11.39-10.9-3.41-7.19-31.74-63.05-33.14-65.66-1.28-2.68-2.31-4.39-4.81-5.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.13,128.44c0,7.74-6.03,14.38-13.34,14.38s-10.78-3.65-14.13-10.36c-2.5-5.12-30.58-60-32.47-63.53-1.95-3.53-3.72-7.19-7.37-8.65h29.24c5.36,0,7.37,3.78,10.78,10.9,2.92,5.91,19.13,36.12,23.63,46.29,1.16,2.74,3.65,6.88,3.65,10.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    "data-name": "SVGID-5",
    d: "M151.26,44.2c0-6.88-5.54-12.43-12.43-12.43s-12.43,5.54-12.43,12.43,5.54,12.43,12.43,12.43,12.43-5.54,12.43-12.43",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    "data-name": "SVGID-6",
    d: "M13.04,140.93h0c-6.88-3.53-9.56-11.94-6.09-18.76,0,0,24.73-48.37,27.72-54.15,2.92-5.79,7.86-7.8,11.82-7.8h4.75c4.81,2.44,9.99,8.83,9.99,13.89,0,2.13-.49,4.32-1.52,6.34l-27.84,54.4c-3.59,6.88-12,9.62-18.82,6.09",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    "data-name": "SVGID-7",
    d: "M237.33,61.68c-1.71-.85-4.2-1.46-6.7-1.46h-67.49l14.07,27.9h31.07l-17.54,34.05c-3.53,6.88-.79,15.29,6.09,18.76v.12c6.88,3.53,15.29.67,18.76-6.21l27.84-54.34c3.47-6.88.73-15.29-6.09-18.82",
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    "data-name": "SVGID-8",
    d: "M93.27,140.93h0c-6.88-3.53-8.95-13.22-5.42-20.1l27.17-53.12c3.53-6.88,7.31-7.68,10.72-7.68l8.04,1.58c6.88,3.53,9.56,11.94,6.09,18.76l-27.84,54.52c-3.53,6.82-11.94,9.56-18.76,6.03",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "r",
    "data-name": "SVGID-9",
    d: "M71.15,115.28c0-6.4-5.18-11.63-11.63-11.63s-11.63,5.18-11.63,11.63,5.18,11.63,11.63,11.63,11.63-5.24,11.63-11.63",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43,60.1c0,.06,25.46,0,25.46,0,4.51,0,7.37,1.71,9.81,5.73,2.38,3.96,33.44,64.63,35.39,68.16,1.95,3.53,4.14,7.8,7.61,8.65h-28.93c-5.06,0-7.98-3.78-11.39-10.9-3.41-7.19-31.74-63.05-33.14-65.66-1.28-2.68-2.31-4.39-4.81-5.97",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.49,128.38c0,7.74-6.03,14.38-13.34,14.38s-10.78-3.65-14.13-10.36c-2.5-5.12-30.58-60-32.47-63.53-1.95-3.53-3.72-7.19-7.37-8.65h29.24c5.36,0,7.37,3.78,10.78,10.9,2.92,5.91,19.13,36.12,23.63,46.29,1.16,2.74,3.65,6.88,3.65,10.96",
    style: {
      fill: "#2b215b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    "data-name": "SVGID-10",
    d: "M151.62,44.14c0-6.88-5.54-12.43-12.43-12.43s-12.43,5.54-12.43,12.43,5.54,12.43,12.43,12.43,12.43-5.54,12.43-12.43",
    style: {
      fill: "#2b215b"
    }
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthidAuthenticator);
export default __webpack_public_path__ + "static/media/authid-authenticator.2e268cb68d835c52b3207bf1b268d320.svg";
export { ForwardRef as ReactComponent };